function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10 1c-4.962 0-9 4.038-9 9s4.038 9 9 9 9-4.038 9-9-4.038-9-9-9zm0 1.5c4.151 0 7.5 3.349 7.5 7.5s-3.349 7.5-7.5 7.5A7.489 7.489 0 012.5 10c0-4.151 3.349-7.5 7.5-7.5z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.5 7a.75.75 0 000 1.5h9a.75.75 0 000-1.5h-9zM7 10a.75.75 0 000 1.5h6a.75.75 0 000-1.5H7zm1.5 3a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z",
  fill: "#000"
})));